import { useEffect } from "react";
import * as serviceWorker from "../serviceWorker";

const KEEP_WORKER_PATTERN =
  /voxpont-sw\.js|voxpont302-sw\.js|firebase-messaging-sw\.js/i;

export function shouldKeepServiceWorker(scriptURL) {
  return KEEP_WORKER_PATTERN.test(scriptURL || "");
}

// This app is built with Vite, which does not emit a `service-worker.js`. The
// SPA host therefore answers requests for `/service-worker.js` with `index.html`
// (`text/html`), so any registration attempt fails with a SecurityError. We
// unregister leftover Create-React-App workers so clients stop being served
// stale cached assets — but keep VoxPont install/offline workers and FCM.
const ServiceWorkerWrapper = () => {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      return undefined;
    }
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          const scriptURL =
            registration.active?.scriptURL ||
            registration.waiting?.scriptURL ||
            registration.installing?.scriptURL ||
            "";
          if (shouldKeepServiceWorker(scriptURL)) return;
          if (scriptURL.includes("service-worker.js")) {
            registration.unregister();
          }
        });
      })
      .catch(() => {
        serviceWorker.unregister();
      });
    return undefined;
  }, []);

  return null;
};

export default ServiceWorkerWrapper;
